(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomResourceTypeAttributeDeleteController',CustomResourceTypeAttributeDeleteController);

    CustomResourceTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomResourceTypeAttribute'];

    function CustomResourceTypeAttributeDeleteController($uibModalInstance, entity, CustomResourceTypeAttribute) {
        var vm = this;

        vm.customResourceTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomResourceTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
